<template>
    <zj-layout-container v-loading="loading" :element-loading-text="loadingText">
      <zj-layout-header>
        <div class="listtitle">医疗资源</div>
        <el-form class="zj-search-form" ref="form" :model="form" :label-width="labelWidth">
          <el-form-item label="医疗机构名称" prop="ResourceName">
            <el-input v-model="ResourceName"></el-input>
          </el-form-item>
          <el-form-item label class="right">
            <el-button @click="onSearch">查 询</el-button>
            <el-button @click="onCancel">清 理</el-button>
          </el-form-item>
        </el-form>
        <el-divider></el-divider>
      </zj-layout-header>
      <zj-layout-main style="padding-top:0px;">
        <zj-layout-container>
          <zj-layout-header>
            <div class="zj-button-bar">
              <el-button size="mini" @click="onAdd">添 加</el-button>
              <el-button size="mini" @click="onbatchDel">删 除</el-button>
            </div>
          </zj-layout-header>
          <zj-layout-main style="padding:0.8rem 0px 0px 0px;">
            <el-table
              :data="tableData"
              ref="multipleTable"
              @selection-change="selectionChange"
              border
              style="width: 100%"
              height="100%"
            >
              <el-table-column type="selection" width="55" align="center"></el-table-column>
              <el-table-column type="index" label="序号" width="80" align="center"></el-table-column>
              <el-table-column prop="ResourceName" label="医疗机构名称" align="center"></el-table-column>
              <el-table-column prop="MedicalType" label="医疗机构类型" :formatter="ConvertMedicalType" align="center"></el-table-column>
              <el-table-column prop="HospitalGrade" label="等级" :formatter="ConvertHospitalGrade" align="center"></el-table-column>
              <el-table-column prop="Address" label="地址" align="center"></el-table-column>
              <el-table-column prop="EmergencyBed" label="急救床位" align="center"></el-table-column>
              <el-table-column prop="Contact" label="联系人" align="center"></el-table-column>
              <el-table-column prop="Phone" label="联系电话" align="center"></el-table-column>
              <el-table-column prop="ModifyTime" label="修改时间" :formatter="formatDate" width="180" align="center"></el-table-column>
              <el-table-column label="操作" width="130" align="center">
                <template slot-scope="scope">
                  <el-button @click="handleClick(scope.$index,scope.row)" type="text" size="small">查看</el-button>
                  <el-button @click="editClick(scope.$index,scope.row)" type="text" size="small">编辑</el-button>
                  <el-button @click="deleteClick(scope.$index,scope.row)" type="text" size="small">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </zj-layout-main>
        </zj-layout-container>
      </zj-layout-main>
      <zj-layout-footer>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          background
          :total="total"
        ></el-pagination>
      </zj-layout-footer>
    </zj-layout-container>
</template>

<script>
import ZJApp from '../../../../../app';
import MyApis from "../../../apis";
const utils = ZJApp.ZJUtils;
export default {
  name: "ZjMedicalresourceslist",
  controller: "EmergencyResource",
  action: "Medicalresourceslist",
  data() {
    return {
      loading: false,
      loadingText: '加载中...',
      currentPage: 1,
      pageSize: 20,
      total: 0,
      tableData: [],
      selectData: null,
      ResourceName: "",
      MedicalTypeDic:[],
      HospitalGradeDic:[]
    };
  },
  created: function() {
    this.basedatabind()
    .then(()=>{
      this.search();
    });
    this.logInfo.ActionName = "医疗资源查看";
    this.logInfo.LogMessage = "医疗资源查看";
    this.logInfo.ModuleName = "应急系统";
    this.logInfo.PageName = "医疗资源管理列表页面";
    this.addOperationLog();
  },
  methods: {
    // 弹出一个错误消息
    errmsg(msg) {
      this.$message({
        showClose: true,
        message: msg || "",
        type: "error",
        customClass: "zj-login-msgbox"
      });
    },
    // 表格的选中 可以获得当前选中的数据
    selectionChange(val) {
      // 将选中的数据存储起来
      this.selectData = val;
    },
    search() {
      let searchInfo = {
        ResourceName:this.ResourceName,
        PageSize: this.pageSize,
        PageIndex: this.currentPage,
        TotalCount: 0,
        StartNumber: 0,
        EndNumber: 0
      };
      this.loading = true;
      this.loadingText = '加载中...';
      new MyApis.MedicalresourcesApi()
        .GetPageContentByConditions(searchInfo)
        .then(r => {
          //console.log("1");
          r = r.data.Data;
          this.tableData = r.PageContents;
          this.total = r.BaseSearch.TotalCount;
          this.loading = false;
        })
        .catch(e => {
          console.error(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          this.loading = false;
        });
    },
    clearsearch() {
      this.ResourceName = "";
    },
    //基础数据绑定
    basedatabind() {
      this.loading = true;
      this.loadingText = '加载中...';
      return utils.waitAll([
        this.config.getUValue("EmergencyService:MedicalType:", ""),
        this.config.getUValue("EmergencyService:HospitalGrade:", "")
      ])
      .then(r => {

        let d = r[0];
        for(let i = 0; i < d.JValue.length; i++) {
          let item = d.JValue[i];
          this.MedicalTypeDic[item.ItemKey]=item.Extend1;
        } 

        d = r[1];
        for(let i = 0; i < d.JValue.length; i++) {
          let item=d.JValue[i];
          this.HospitalGradeDic[item.ItemKey]=item.Extend1;
        }
        
        this.loading = false;

        return r;
      })
      .catch(e => {
        console.error(e);
        this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        this.loading = false;
      });
      
    },
    // 点击查询按钮
    onSearch() {
      this.currentPage = 1;
      this.search();
    },
    // 点击取消按钮
    onCancel() {
      this.clearsearch();
      this.search();
    },
    //编辑按钮
    editClick(index, row) {
      this.$router.push({
        path: "/plugin/emergency/EmergencyResource/Medicalresourcesinfo",
        // name: 'mallList',
        query: {
          obj: row.ResourcesId,
          type: "edit"
        }
      });
    },
    //查看详细
    handleClick(index, row) {
      //console.log(index, row);
      this.$router.push({
        path: "/plugin/emergency/EmergencyResource/Medicalresourcesinfo",
        // name: 'mallList',
        query: {
          obj: row.ResourcesId,
          type: "search"
        }
      });
    },
    //添加
    onAdd() {
      this.$router.push({
        path: "/plugin/emergency/EmergencyResource/Medicalresourcesinfo",
        // name: 'mallList',
        query: {
          obj: null,
          type: "edit"
        }
      });
    },
    //批量删除
    onbatchDel() {
      if (
        this.selectData != undefined &&
        this.selectData != null &&
        this.selectData.length > 0
      ) {
        this.$confirm("选中的数据将被永久删除, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            const selectData = this.selectData;
            const count = selectData.length;
            // 清除 所有勾选项
            this.$refs.multipleTable.clearSelection();
            if (count > 0) {
              this.loading = true;
              this.loadingText = '删除中...';
              new MyApis.MedicalresourcesApi()
                .DelItemList(selectData)
                .then(r => {
                  r = r.data.Data;
                  if (r) {
                    this.$message({
                      type: "success",
                      message: "删除成功!"
                    });
                  } else {
                    this.$message({
                      type: "error",
                      message: "删除失败!"
                    });
                  }
                  this.loading = false;
                  this.search();
                })
                .catch(e => {
                  console.error(e);
                  this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
                  this.loading = false;
                });
            }
          });
      } else {
        this.$message({
          type: "info",
          message: "未选中任何行！"
        });
      }
    },
    //行删除
    deleteClick(index, row) {
      this.$confirm("此操作将永久删除该行数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.loading = true;
          this.loadingText = '删除中...';
          new MyApis.MedicalresourcesApi()
            .DelItem(row)
            .then(r => {
              r = r.data.Data;
              if (r) {
                this.$message({
                  type: "success",
                  message: "删除成功!"
                });
              } else {
                this.$message({
                  type: "error",
                  message: "删除失败!"
                });
              }
              this.loading = false;
              this.logInfo.ActionName = "医疗资源删除";
              this.logInfo.LogMessage = r ? "医疗资源删除成功" : "医疗资源删除失败";
              this.logInfo.ModuleName = "应急系统";
              this.logInfo.PageName = "医疗资源管理列表页面";
              this.addOperationLog();
              this.search();
            })
            .catch(e => {
              console.error(e);
              this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
              this.loading = false;
            });
        });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search();
    },
    ConvertMedicalType(row, column) {
      let data = row[column.property];
      if (data == null) {
        return null;
      }
      let levelstr=this.MedicalTypeDic[data];
      return   levelstr ;
    },
    ConvertHospitalGrade(row, column) {
      let data = row[column.property];
      if (data == null) {
        return null;
      }
      let levelstr=this.HospitalGradeDic[data];
      return   levelstr ;
    },
    //日期列表展示格式
    formatDate(row, column) {
      // 获取单元格数据
      let data = row[column.property];
      if (data == null || data == "0001-01-01T00:00:00") {
        return null;
      }
      return new Date(data).format('yyyy-MM-dd hh:mm:ss');
    }
  }
};
</script>